import * as React from "react";
import {Linear, TimelineMax, TweenMax} from "gsap";

class SvgSuccessSpaceman extends React.Component {

  componentDidMount() {
    this.animateAstronaut();
  }

  animateAstronaut = () => {
    const astronaut = document.getElementById('success-spaceman-new_svg__Spaceman');
    const jetBubbles = document.getElementsByClassName('success-spaceman-new_svg__bubble');

    // Shake the spaceman
    TweenMax.to(astronaut, 0.05, {
      y: '+=4',
      repeat: -1,
      yoyo: true
    })
    const mainTimeline = new TimelineMax({repeat: -1});
    mainTimeline.timeScale(6).seek(100);

    // Jet bubbles
    TweenMax.set(jetBubbles, {
      attr: { r: '-=5' }
    });
    for (let i = 0; i < jetBubbles.length; i++) {
      const jb = jetBubbles[i];
      const tl = new TimelineMax({repeat: -1});
      tl.to(jb, 1, {
        attr: { r: '+=15' },
        ease: Linear.easeNone
      }).to(jb, 1, {
        attr: { r: '-=15' },
        ease: Linear.easeNone
      });
      mainTimeline.add(tl, i / 4);
    }
  }

  render() {
    const { props } = this;
    return (
        <svg viewBox="0 0 600 600" {...props}>
          <style>
            {
              ".success-spaceman-new_svg__st1{fill:#fff}.success-spaceman-new_svg__st2{fill:#662a20}.success-spaceman-new_svg__st3{fill:#993f30}.success-spaceman-new_svg__st4{fill:#cc583f}.success-spaceman-new_svg__st5{fill:#2d2d2d}.success-spaceman-new_svg__st7{fill:#7f3428}.success-spaceman-new_svg__st8{fill:#a84535}.success-spaceman-new_svg__st9{fill:#e55e48}.success-spaceman-new_svg__st11{fill:#7f7f7f}.success-spaceman-new_svg__st12{fill:#ddd}.success-spaceman-new_svg__st15{fill:#1d1d1d}.success-spaceman-new_svg__st17{fill:#558793}.success-spaceman-new_svg__st19{display:none}.success-spaceman-new_svg__st21{display:inline}.success-spaceman-new_svg__st23,.success-spaceman-new_svg__st25,.success-spaceman-new_svg__st27{fill:none;stroke-linejoin:round}.success-spaceman-new_svg__st23{stroke:#ededed;stroke-miterlimit:10}.success-spaceman-new_svg__st25,.success-spaceman-new_svg__st27{stroke:#2d2d2d}.success-spaceman-new_svg__st25{stroke-linecap:round}.success-spaceman-new_svg__st27{stroke-width:1.5814;stroke-miterlimit:10}"
            }
          </style>
          <g id="success-spaceman-new_svg__Spaceman_star_container">
            <path
                id="success-spaceman-new_svg__Spaceman_star"
                opacity={0.7}
                fill="#ECB447"
                d="M1.2 0l.4.8.8.1-.6.6.1.8-.7-.4-.7.4.1-.8L0 .9.8.8z"
            />
          </g>
          <g id="success-spaceman-new_svg__Spaceman_jets">
            <path
                className="success-spaceman-new_svg__st2"
                d="M293 287.1h5.6v118.6H293z"
            />
            <path
                className="success-spaceman-new_svg__st3"
                d="M298.5 287.1h5.6v118.6h-5.6z"
            />
            <path
                className="success-spaceman-new_svg__st4"
                d="M304.1 287.1h5.6v118.6h-5.6z"
            />
            <path
                className="success-spaceman-new_svg__st3"
                d="M309.7 287.1h5.6v118.6h-5.6z"
            />
            <path
                className="success-spaceman-new_svg__st2"
                d="M315.3 287.1h5.6v118.6h-5.6z"
            />
          </g>
          <g id="success-spaceman-new_svg__Spaceman_bubbles">
            <g id="success-spaceman-new_svg__greyJets_1_">
              <circle
                  className="success-spaceman-new_svg__bubble success-spaceman-new_svg__st5"
                  cx={304.7}
                  cy={425.5}
                  r={18.1}
              />
              <circle
                  className="success-spaceman-new_svg__bubble success-spaceman-new_svg__st5"
                  cx={289.7}
                  cy={410.5}
                  r={15.8}
              />
              <circle
                  className="success-spaceman-new_svg__bubble success-spaceman-new_svg__st5"
                  cx={328.4}
                  cy={420.7}
                  r={16.6}
              />
            </g>
            <g id="success-spaceman-new_svg__colorJets_1_">
              <circle cx={322.8} cy={393.9} r={6.3} fill="#bf493d" />
              <circle
                  className="success-spaceman-new_svg__bubble success-spaceman-new_svg__st2"
                  cx={326.8}
                  cy={416}
                  r={10.3}
              />
              <circle
                  className="success-spaceman-new_svg__bubble success-spaceman-new_svg__st2"
                  cx={305.5}
                  cy={402.6}
                  r={7.9}
              />
              <circle
                  className="success-spaceman-new_svg__bubble success-spaceman-new_svg__st7"
                  cx={336.3}
                  cy={397.1}
                  r={8.7}
              />
              <circle
                  className="success-spaceman-new_svg__bubble success-spaceman-new_svg__st4"
                  cx={302.3}
                  cy={405}
                  r={5.5}
              />
              <circle
                  className="success-spaceman-new_svg__bubble success-spaceman-new_svg__st7"
                  cx={304.7}
                  cy={409.7}
                  r={18.9}
              />
              <circle
                  className="success-spaceman-new_svg__bubble success-spaceman-new_svg__st2"
                  cx={281.8}
                  cy={394.7}
                  r={15.8}
              />
              <circle
                  className="success-spaceman-new_svg__bubble success-spaceman-new_svg__st8"
                  cx={328.4}
                  cy={405}
                  r={7.9}
              />
              <circle
                  className="success-spaceman-new_svg__bubble success-spaceman-new_svg__st8"
                  cx={305.5}
                  cy={404.2}
                  r={14.2}
              />
              <circle
                  className="success-spaceman-new_svg__bubble success-spaceman-new_svg__st9"
                  cx={322.8}
                  cy={389.2}
                  r={16.6}
              />
              <circle
                  className="success-spaceman-new_svg__bubble success-spaceman-new_svg__st9"
                  cx={293.7}
                  cy={389.5}
                  r={9.5}
              />
            </g>
          </g>
          <g id="success-spaceman-new_svg__Spaceman">
            <g id="success-spaceman-new_svg__Spaceman_badge">
              <g id="success-spaceman-new_svg__XMLID_1_">
                <path
                    className="success-spaceman-new_svg__st1"
                    d="M309.9 299.5c-1 .1-2 .1-3 0v.1c-.9 3.6-3.9 5.9-6.7 10.4.6 1 7.4 17.5 7.1 18.9-.3 1.4-4.9 8.9-7.5 11.3-3.8 3.4-7.6 7.1-11.6 7.6-2.8.3-7.9-4.8-7.9-8.1s3.1-8.7 10.4-14.1c2-1.7-5.9-8.2-9.4-17.9-1.4-4 3.2-9.2 6.9-12.8 0-.3 0-.6.1-.9.7-10.5.4-15.8.5-22.8-1.2-1.1-4.6-5.1-8.4-10-5.5-6.9-11.9-15.3-14.2-19-4.9-7.7-8.3-27.2-9.1-31.3-.1-.7-2.2-2.2-4.5-4.8-2.5-2.8-2.6-8.4-1.9-10.3 1-2.6 10.9-6.8 13.8-6.4 2.4.4 6.6 2.6 7.7 7 .7 2.5.6 4.3-.8 5.8-.5 5-2.7 6-2.7 6-1.3 4.5 7.4 25.1 9 27.6 1.6 2.5 5.8 8.5 9.1 12.4 1.4 1.7 5.5 3.1 6.2 2.4 1.1-1.2.1-1.5 1.1-2.4.1-.1.2-.1.3-.2 3.1-1.8 6.5-2.8 12.2-2.8 4.7 0 8.4 1.4 11.1 3 .5.3 1 .6 1.4 1 1.4 1.1.6 1.9 1.2 2.4.5.4 1.4 0 3.6 1.1s4.8 4 7.5 7.5l.9 1.2c.6.9 1.3 1.8 1.9 2.7 5 7.2 9.6 15.7 11 18.9 2.5 5.6 1.8 21.7 1 23.9-.8 2.1-8.8 3.9-10.6 3.1-1.5-.6-4.5-4.2-5.2-6.8-.2-.6-.2-1.1-.1-1.5.2-1.2 1.9-2.2 3.8-2.9 1.2-2 1.5-7.4 1.5-9.7 0-.9-1.5-2.9-3.3-5.1-2.8-3.3-6.4-7.2-7.2-8.8 0 5.1-.5 11.1-.2 18.2 0 .1.2.5.3.9.1.3.2.5.3.6 1.5 3.4 2.6 5.9 3.6 8.8.5 1.4.9 2.9 1.3 4.6.8 3.4-.3 6.1-1.5 9-3.4 8.4-4.9 14.4-3.4 15.9.2.2.5.4.7.6 5.8 4.7 8 11.2 8 14.3 0 3.1-6.1 7.1-8.7 6.8-2.4-.3-5-1.8-9.8-6.8-3.8-4-5.1-6.7-6.3-8.8-.6-1.1 3.1-15.9 4.2-25.6.7-8.5-3.4-13-3.7-14.2z"
                />
                <path
                    d="M334.9 234c7.3 8.3 12.2 18.7-.9 29.9-.6-.9-1.3-1.8-1.9-2.7l-.9-1.2c.3-.2.6-.5.9-.7 8.4-7.2 4.7-16.1.1-21.2 1-1.3 1.9-2.7 2.7-4.1z"
                    fill="#4c4c4c"
                />
                <path
                    className="success-spaceman-new_svg__st1"
                    d="M338.8 219.8c0 5-1.4 9.8-3.9 14.1-.8 1.4-1.8 2.8-2.8 4.2-3.1 3.9-7 7.3-11.5 9.9-.6.3-1.1.7-1.7 1-.4-.3-.9-.6-1.4-1-2.6-1.6-6.3-3-11.1-3-5.7 0-9.1 1-12.2 2.8-11.5-4.1-19.1-15.2-19.1-28 0-17.6 14.2-31.8 31.8-31.8 17.7 0 31.9 14.3 31.9 31.8zm-4.5 3.4c.8-1.7.6-3.7.6-5.6 0-15.4-12.5-27.9-27.9-27.9-15.4 0-27.8 12.5-27.8 27.9 0 2 .2 4.1 1.2 5.8.9 1.5 3.1 2.3 5.3 1.5 1.9-.8 10.6-5.1 21.3-5.1 10.8 0 21.6 5.9 23 5.9 1.4 0 3.6-.9 4.3-2.5z"
                />
                <path
                    className="success-spaceman-new_svg__st11"
                    d="M332.1 283.8v6.6c0 2-1.6 3.6-3.6 3.6H325c-.2-.3-.3-.7-.3-.9-.3-7.1.2-13.1.2-18.2.8 1.6 4.4 5.5 7.2 8.9zM332.1 251.7v7.7c-.3.2-.6.5-.9.7-2.7-3.5-5.3-6.4-7.5-7.5-2.2-1.1-3.1-.7-3.6-1.1-.6-.5.2-1.3-1.2-2.4.6-.3 1.2-.6 1.7-1h7.8c2.1 0 3.7 1.6 3.7 3.6zM286.8 248.1h7.3c-1 .9 0 1.2-1.1 2.4-.7.7-4.8-.8-6.2-2.4zM288.8 271.1c0 7.1.2 12.4-.5 22.8H284c-2 0-3.6-1.6-3.6-3.6v-29.2c3.8 4.9 7.2 8.9 8.4 10z"
                />
              </g>
              <path
                  className="success-spaceman-new_svg__st12"
                  d="M324.9 269.5c2.1 4.4 9.4 14.4 11.1 16.6 1 1.2.4 8.8-.3 11.4 0 0-.1.3-1.8 1.2 0 0 1.5-2.1 1.5-10 0-1.4-7.1-8.3-10.5-13.5v-5.7zM327.3 195.2c6.7 5.4 11.4 13.9 11.6 24.2.2 10.3-6.3 19.1-9.6 22.1s-8.5 6.5-10.2 7.5c0 0-5.4-4-11.9-4-6.6.1-11.6 1.9-12.7 2.8 0 0-1-.4-1.4-.5-.5-.2-1.7-.8-1.7-.8 3-2.6 6.6-4.1 11.8-4.4 5.2-.3 10.9-.1 13.3 1.4 0 0 4.9 1 11-5.4s9.3-11.3 9.9-19.1c.6-7.7-6.1-24.5-20.4-29.6-.3.2 5 1.6 10.3 5.8z"
              />
              <path
                  className="success-spaceman-new_svg__st12"
                  d="M335.4 309.9c-3-2.3 7.5-1.9 8.6-3.8 1.1-1.9.1-13.4-1-20.4-.6-3.8-7.8-17.4-14.4-26.3-3.8-5.1-8.9-8.1-8.5-7.9.5.3.8.3 1.7.4 6.9.9 18.1 20.8 23.2 31 3.1 6.1 1.8 24 0 24.9s-7.9 3.3-9.6 2.1zM271.3 202.1s-.1 1.4-.6 2.9c-.4 1.3-1.3 2.6-2.1 3.1 0 0-.4 2.4.7 6.4 1.2 4.1 5.3 15.6 8.1 20.9s7.1 9.8 9.1 12.6c1.6 2.2 6.1 3.1 6.4 3 .3-.1-1.2.7-1.7.8s-4.4-.7-6.3-3.1c-1.9-2.4-8.5-10.7-9.7-13-1.1-2.3-7.2-16.5-7.9-21.3-.7-4.8-1.4-6.9-1.3-7.6.1-.7-1.8.4-4.2.1-2.4-.4-4.1-1.2-5.1-2.3 0 0 2.7 1.9 6.7 1 2.3-.5 4.5-1.2 6-2 1.1-.7 1.9-1.5 1.9-1.5z"
              />
              <path
                  d="M333.1 207.8c1.9 4.7 2.3 11.8 1.5 14.6-.8 2.8-2.9 3.9-4.6 3.4-1.6-.5-14.2-5.9-23-5.9s-17.5 3.8-20.3 4.6c0 0 8.4-9.1 20.3-10.2 11.9-1.1 19.3 5.1 20.6-.4 1.1-4.8-.1-8.8-2.8-14.5-2.2-4.7-6.6-7.2-6.6-7.2s1.6-.3 7 4.5c4.7 4 6.1 6.8 7.9 11.1z"
                  fill="#586e79"
              />
              <path
                  d="M303.6 190c7.3-.2 14 8.9 14 10.8 0 2.3-4.9.3-7.3.1-6.5-.6-16.2 3.2-21.5 8.2-3.2 3.1-8.3 13.7-7.8 15.1 0 0-1-.2-1.4-2.6-.4-2.4-1.1-9.9 1.8-15 2.9-5.1 5-8.9 8.9-11.3 8.9-5.5 13.3-5.3 13.3-5.3z"
                  fill="#698491"
              />
              <path
                  className="success-spaceman-new_svg__st12"
                  d="M302.6 298s1.4 3.6-4.5 10.1c-1.1 1.3-2.8 1.6-2.3 2.1.6.5 8.1 12.6 8.1 16.9.1 4.3-11.5 15.7-13.5 16.8-2.1 1.1-4.8-.3-6.3-2s-2.8-3.8-3-5.6c0 0-1 1.9-.7 3.2.2 1.4.2 2.4 1.7 4.1s3 3.1 4 3.5 2.7.7 4.2 0c1.6-.7 7.8-4.8 10.1-7.7 2.3-2.9 6.4-8.9 6.9-10.7.5-1.6-5.2-14.2-7.1-18.9 0 0 1.5-2.2 3.9-5.2 3.1-3.9 2.8-5.4 2.8-5.4s-2.5-.2-4.3-1.2zM310.4 299.7c.4.9 2.6 3.9 3 6.2.4 2.3 1.5 4.1.4 10.5s-4.1 20.9-3.9 22c.2 1.1 2.5 5.2 4.3 7.1 1.4 1.4 7.4 8.3 12 9.1 0 0-2.6.6-5.6-1.9s-5.7-5-7.2-6.9c-1.5-2-4.1-5.1-4.4-6.8-.3-1.8 1.5-9 2.1-12.7s2-9.9 2.3-13.9c.2-3.9-.4-6.2-1.5-8.7-.8-1.8-.7-1.5-2-3.8l.5-.2z"
              />
              <path
                  className="success-spaceman-new_svg__st12"
                  d="M326.3 354.6c2.1-2.2 5.5-4.5 6.1-6.2s-6.1-11.8-7.5-13.5c-1.4-1.7-4.2-4.2-5.4-3.8 0 0 .8-.8 2.1-.3s7.3 3.5 9.7 8.8 3.1 7.1 2.8 8.3c-.3 1.2-1.2 3.1-2.7 4.2s-5.1 2.5-5.1 2.5z"
              />
              <path
                  className="success-spaceman-new_svg__st12"
                  d="M324.9 267.5c-1.5 1.7-2 1.4-2 3s.1 17.8-.8 20.7-.9 2.8.4 4.3 5.2 9.3 5.5 12.6c.4 3.3.2 5.6-.7 9.2-1 3.9-3.4 10.6-5.8 13.5 0 0 2.9 2.1 3.3 1.8 0 0-.1.4-.3-1.3-.2-1.7.3-3.1 1-5.3s2.7-8.2 4-11.1c1.3-3 1.2-4.9.3-8-.9-3.1-3.5-10.9-5-12.8-.7-1-.4-4.8-.3-8s.4-18.6.4-18.6zM256.8 191.5c4.9-.2 5.2-.8 8.4.7s6.2 4.1 6.2 7.1-1.9 4.3-1.9 4.3-2 3.8 1.9-1.3c.6-.7 1.7-2 .8-5.8-1-3.9-4.3-6.1-6.7-6.8-2.4-.6-4.6 0-6.6.9s-2.1.9-2.1.9zM281.1 262.1c6.5 5.4 9.1 4.4 9.3 5.1.2.7-.7 12.5-1.3 18.6-.2 1.6-.5-.5-.5-2 0-3.5.2-12.6.2-12.7l-.9-1-6.8-8zM308.1 258.6c3.4-.3 4.9.7 6.2 1.9 1.3 1.1 5.1 4.8 3.2 10.9-1.5 4.9-4.7 7-7.8 7.4-3.5.5-6.1-1.1-6.5-1.3"
              />
              <path
                  className="success-spaceman-new_svg__st15"
                  d="M294.3 247.9c-3.4-1.2-6.6-3-9.3-5.4-2.7-2.4-5-5.3-6.6-8.5-3.4-6.5-4.1-14.1-2.6-21.2 1.5-7.1 5.7-13.6 11.4-18.1 5.7-4.6 13-7 20.3-6.9 7.3.1 14.5 2.8 20.1 7.5 5.6 4.7 9.5 11.3 10.9 18.4l.4 2.7c.1.9.1 1.8.2 2.7.1 1.8-.1 3.6-.4 5.4-.7 3.6-2 7-3.9 10.1-1.9 3.1-4.2 5.9-6.9 8.3-2.7 2.4-5.7 4.4-8.9 6.1 3.2-1.7 6.1-3.8 8.8-6.3 2.6-2.4 4.9-5.3 6.7-8.4 1.8-3.1 3.1-6.5 3.7-10 .3-1.8.4-3.6.4-5.3-.1-.9-.1-1.8-.2-2.7l-.4-2.7c-1.4-7-5.3-13.5-10.8-18.1-5.5-4.5-12.6-7.2-19.7-7.2-7.1-.1-14.3 2.2-19.9 6.7-5.6 4.4-9.8 10.7-11.3 17.7-1.6 7-.9 14.5 2.4 20.9 1.6 3.2 3.8 6.2 6.4 8.6 2.7 2.6 5.8 4.5 9.2 5.7zM324.9 267.5l.2 8.5c0 2.8-.1 5.6-.1 8.5 0 2.8-.1 5.6.1 8.4v.5c0 .1.1.3.2.4l.4 1 .9 1.9c.6 1.3 1.1 2.6 1.7 3.9 1 2.6 1.8 5.4 2.4 8.2.2 1.4.1 2.9-.2 4.3-.3 1.4-.9 2.7-1.4 4-1.1 2.6-2.1 5.2-3 7.9-.4 1.3-.8 2.7-1.1 4.1-.1.7-.2 1.4-.2 2.1 0 .7.1 1.4.6 2-.5-.5-.6-1.3-.6-2s.1-1.4.2-2.1c.2-1.4.6-2.8 1-4.1.8-2.7 1.8-5.4 2.8-8 .5-1.3 1-2.6 1.3-4 .3-1.4.3-2.7.1-4.1-.6-2.7-1.4-5.4-2.4-8-.5-1.3-1.1-2.6-1.7-3.9l-.9-1.9-.4-1c-.1-.2-.1-.3-.2-.6v-.6c-.1-2.8-.1-5.7 0-8.5s.3-5.6.3-8.4v-8.5z"
              />
              <path
                  className="success-spaceman-new_svg__st15"
                  d="M309.9 299.7c.5 1 1.1 1.8 1.6 2.8.5.9.9 1.9 1.2 2.9.7 2 1 4.1.9 6.3 0 2.1-.4 4.2-.7 6.3-.3 2.1-.7 4.2-1.1 6.2-.7 4.1-1.6 8.3-2.3 12.4-.1.5-.1 1-.2 1.5V338.9l.1.2.2.3c.5.9 1 1.8 1.6 2.7 1.1 1.8 2.4 3.4 3.9 4.9 1.4 1.5 2.9 3 4.5 4.3 1.6 1.3 3.4 2.5 5.4 2.8.9.2 1.9-.2 2.9-.6.9-.4 1.8-1 2.6-1.6.8-.6 1.6-1.3 2.2-2.1.3-.4.6-.8.7-1.3.2-.5.2-.9.1-1.4-.2-2-.9-4-1.8-5.9-.9-1.9-2.1-3.6-3.5-5.2s-3-2.9-4.7-4.2c-.9-.6-1.8-1.2-2.8-1.3-.5-.1-1 .1-1.5.4-.4.3-.8.7-1.1 1.1.3-.4.7-.8 1.1-1.2.4-.3 1-.5 1.5-.5 1.1.1 2 .7 2.9 1.2 1.8 1.2 3.4 2.5 4.9 4.1 1.5 1.6 2.7 3.3 3.6 5.2.9 1.9 1.7 3.9 1.9 6.1 0 .5.1 1.2-.2 1.7-.2.5-.5 1-.8 1.5-.7.9-1.5 1.6-2.3 2.3-.9.7-1.8 1.2-2.8 1.7-1 .4-2.1.8-3.3.6-2.2-.4-4.1-1.6-5.7-3-1.7-1.4-3.1-2.9-4.6-4.4-1.4-1.6-2.8-3.2-3.9-5-.6-.9-1.1-1.8-1.6-2.8l-.2-.3-.1-.2v-.1c0-.1-.1-.1-.1-.2-.1-.4 0-.6 0-.9 0-.5.1-1.1.2-1.6.7-4.2 1.6-8.3 2.4-12.4.4-2.1.8-4.1 1.1-6.2.3-2.1.7-4.2.8-6.2.1-2.1-.1-4.2-.8-6.2-.3-1-.7-2-1.2-2.9 0-.8-.6-1.6-1-2.6z"
              />
              <path
                  className="success-spaceman-new_svg__st15"
                  d="M302.6 298c1.5.6 2.9 1 4.4 1.2 1.5.2 3 .2 4.6 0-1.4.8-3.1.9-4.7.7-1.6-.2-3.2-.8-4.3-1.9z"
              />
              <path
                  className="success-spaceman-new_svg__st15"
                  d="M298.3 325.6c-.5-.7-1.2-1.4-2-1.7-.9-.3-1.8-.2-2.6.2-1.7.6-3.1 1.8-4.5 3-2.7 2.3-5.3 4.9-7 8-.8 1.5-1.5 3.3-1.4 5 .2 1.7 1.3 3.2 2.5 4.5 1.2 1.3 2.6 2.5 4.3 2.9.4.1.8.1 1.2 0 .4-.1.8-.2 1.3-.3.8-.3 1.6-.7 2.4-1.1 1.5-.9 2.9-2.1 4.3-3.2l2-1.8c.7-.6 1.4-1.2 1.9-1.8 1.2-1.3 2.2-2.8 3.2-4.3s1.9-3 2.8-4.6c.2-.4.4-.8.5-1.2.1-.2-.1-.8-.2-1.2-.2-.9-.5-1.7-.8-2.6-.6-1.7-1.2-3.4-1.9-5.1-1.3-3.4-2.6-6.7-4-10v-.2c1.1-1.7 2.4-3.4 3.7-5 1.3-1.6 2.5-3.3 3-5.3-.5 2-1.7 3.8-2.9 5.4-1.3 1.6-2.5 3.3-3.6 5v-.1c1.6 3.3 2.9 6.6 4.3 10 .7 1.7 1.3 3.4 2 5.1.3.9.6 1.7.9 2.6.1.2.1.4.2.7 0 .1 0 .2.1.4v.4c-.1.5-.4.9-.6 1.3-.8 1.6-1.8 3.2-2.8 4.7-1 1.5-2 3-3.3 4.4-.6.7-1.3 1.3-2 1.9l-2 1.8c-1.4 1.2-2.8 2.3-4.4 3.3-.8.5-1.6.9-2.5 1.2-.4.1-.9.3-1.4.4-.4.1-1 .1-1.5 0-1-.2-1.8-.7-2.5-1.2-.8-.5-1.4-1.2-2.1-1.9-.6-.7-1.2-1.4-1.6-2.2-.5-.8-.8-1.7-1-2.7-.1-2 .7-3.7 1.5-5.3 1.9-3.2 4.5-5.8 7.3-8 1.4-1.1 2.9-2.3 4.6-2.9.9-.3 1.8-.4 2.7-.1.7.1 1.4.8 1.9 1.6z"
              />
              <path
                  className="success-spaceman-new_svg__st15"
                  d="M290.3 293.1c-2.2 2.3-4.5 4.6-6.4 7.2-.9 1.3-1.7 2.7-2.2 4.1-.2.7-.3 1.5-.2 2.2.1.7.4 1.4.7 2.2 1.2 3 2.8 5.7 4.6 8.4l2.7 4c.4.7.9 1.4 1.2 2.1.2.4.3.7.4 1.1.1.4 0 .9-.3 1.1.3-.3.3-.7.2-1.1-.1-.4-.3-.7-.5-1.1-.4-.7-.9-1.3-1.3-2l-2.9-3.9c-1.9-2.6-3.5-5.4-4.8-8.4-.2-.4-.3-.8-.4-1.1-.1-.4-.3-.8-.3-1.3-.1-.9 0-1.7.3-2.5.5-1.6 1.4-3 2.4-4.3 1.9-2.5 4.3-4.7 6.8-6.7z"
              />
              <path
                  className="success-spaceman-new_svg__st15"
                  d="M288.8 271.2c.2 2 .2 4 .3 5.9.1 2 .1 4 .1 6s-.1 4-.3 5.9c-.2 2-.3 4-.6 5.9V289l.1-5.9.1-5.9c.1-2.1.1-4 .3-6zM319 249.1c.4.3.8.7.9 1.2.1.3.1.5.1.8 0 .2.2.5.5.5.5.1 1 .1 1.5.2s1 .3 1.5.5c1.9.9 3.4 2.4 4.9 3.9 2.8 3.1 5.2 6.5 7.6 10 2.3 3.5 4.4 7.1 6.5 10.7 1 1.8 2 3.7 2.9 5.6.9 2 1.2 4.1 1.5 6.2.4 4.2.5 8.4.2 12.5-.1 1-.1 2.1-.2 3.1-.1.5-.1 1-.2 1.6 0 .3-.1.5-.2.8-.1.3-.3.6-.5.8-.8.8-1.8 1.2-2.8 1.6-1 .4-2 .6-3.1.8-1 .2-2.1.4-3.2.4-.5 0-1.1 0-1.6-.3s-.9-.6-1.3-1c-1.5-1.5-2.8-3.2-3.6-5.2-.2-.5-.3-1-.4-1.6 0-.5.1-1.1.4-1.6.7-.9 1.6-1.4 2.6-1.8 1-.4 1.9-.8 2.9-1.1 1-.3 2-.5 3.1-.6-1 .1-2 .4-3 .7-1 .3-2 .7-2.9 1.1-.9.5-1.9 1-2.4 1.8-.3.4-.4.9-.3 1.4 0 .5.2 1 .4 1.5.8 1.9 2.1 3.6 3.6 5 .4.3.8.7 1.2.9.4.2.9.2 1.4.2 1 0 2-.2 3-.4s2-.5 3-.9c.9-.4 1.9-.8 2.6-1.4.2-.2.3-.3.4-.5.1-.2.1-.5.2-.7.1-.5.1-1 .2-1.5.1-1 .2-2.1.2-3.1.2-4.1.1-8.3-.3-12.4-.3-2-.5-4.1-1.4-6-.9-1.9-1.9-3.7-2.8-5.5-2-3.6-4.1-7.2-6.4-10.7-2.3-3.5-4.6-6.9-7.3-10-1.4-1.5-2.8-3.1-4.7-4-.5-.2-.9-.4-1.4-.6l-1.5-.3c-.3-.1-.5-.3-.5-.6s0-.5-.1-.8c-.5-.5-.8-.9-1.2-1.2zM286.8 248.1c-2.5-2.8-4.7-5.7-6.9-8.8l-1.6-2.3c-.3-.4-.5-.8-.8-1.2-.3-.4-.5-.8-.7-1.3-.8-1.7-1.6-3.4-2.3-5.1-1.5-3.4-2.8-6.9-3.9-10.5-.6-1.8-1.1-3.6-1.5-5.4-.2-.9-.4-1.8-.5-2.8-.1-.9-.2-1.9 0-2.9v-.1h.1c.4-.2.8-.7 1.1-1.1.3-.4.6-.9.8-1.5.4-1 .7-2.1.8-3.3 0 .6-.1 1.1-.2 1.7-.1.6-.2 1.1-.4 1.7-.2.5-.4 1.1-.7 1.6-.3.5-.7 1-1.2 1.3l.1-.1c-.2.9-.1 1.8.1 2.7.1.9.3 1.8.6 2.7.5 1.8 1 3.6 1.6 5.3 1.2 3.5 2.6 7 4 10.4.7 1.7 1.4 3.4 2.2 5.1l.6 1.2.8 1.2 1.5 2.3c1.9 3.3 4.1 6.3 6.4 9.2z"
              />
              <path
                  className="success-spaceman-new_svg__st15"
                  d="M324.9 275.1c.6 1 1.4 1.8 2.2 2.6l2.3 2.5c1.5 1.7 3.1 3.4 4.5 5.2.7.9 1.4 1.8 1.8 3 0 .2.1.3.1.5v1.3c0 .6-.1 1.1-.1 1.7-.1 1.1-.3 2.3-.5 3.4-.3 1.1-.5 2.3-1.2 3.2.5-1 .7-2.2.8-3.3.2-1.1.2-2.3.3-3.4l.1-1.7V288.9c0-.1 0-.2-.1-.3-.4-1-1.1-1.9-1.8-2.8-1.4-1.8-2.9-3.5-4.3-5.3-1.5-1.7-3.1-3.4-4.1-5.4zM307 219.9c6.5 0 12.9 2 19 4.3l2.3.9c.4.1.8.3 1.1.4.4.2.7.2 1.1.1 1.5-.2 3.1-1.1 3.7-2.6.6-1.5.5-3.2.5-4.8 0-.8-.1-1.6-.1-2.4 0-.8-.1-1.6-.3-2.4-.5-3.2-1.6-6.3-3.1-9.1-1.6-2.8-3.7-5.3-6.1-7.4-4.9-4.2-11.3-6.6-17.7-6.7-6.4-.1-12.9 2.1-17.9 6.2-5 4.1-8.5 10-9.7 16.3-.1.8-.3 1.6-.3 2.4l-.1 2.4c0 1.6.1 3.3.6 4.8.3.7.7 1.5 1.3 2 .6.5 1.4.8 2.2.9 1.6.2 3.1-.7 4.6-1.3 5.9-2.5 12.4-4 18.9-4zm0 0c-6.5.1-13 1.6-19 4.1l-2.2 1c-.8.3-1.6.5-2.4.4-.8-.1-1.6-.4-2.3-.9-.7-.5-1.1-1.3-1.4-2.1-.6-1.6-.7-3.2-.7-4.9l.1-2.5.3-2.4c1.1-6.5 4.6-12.5 9.7-16.7 5.1-4.2 11.6-6.5 18.3-6.5 6.6.1 13.1 2.6 18.1 7 2.5 2.2 4.6 4.7 6.2 7.6 1.6 2.9 2.6 6 3.1 9.3.1.8.3 1.6.3 2.4 0 .8.1 1.6.1 2.5 0 1.6.1 3.3-.5 4.9-.3.8-.9 1.4-1.6 1.9-.7.4-1.5.7-2.3.9-.4.1-.9 0-1.2-.1-.4-.1-.8-.3-1.2-.4l-2.3-.9c-6.2-2.5-12.5-4.5-19.1-4.6zM288.8 271.2c-6.8-7.3-12.9-15.2-18.9-23.2-1.5-2-3-4-4.3-6.2-1.3-2.2-2.2-4.5-3-6.9-1.6-4.7-2.9-9.6-4-14.5-.5-2.4-1-4.9-1.5-7.3l-.4-1.8c0-.1-.1-.4-.1-.4-.1-.1-.1-.2-.2-.3-.2-.2-.4-.4-.6-.7-.9-.9-1.8-1.7-2.7-2.6-.4-.5-.9-.9-1.3-1.4-.4-.5-.7-1.1-1-1.7-.5-1.2-.8-2.4-.9-3.7-.1-1.3-.2-2.5.1-3.8.1-.3.1-.6.3-1 .2-.3.3-.6.6-.9.4-.5 1-.9 1.5-1.3 2.1-1.4 4.4-2.5 6.8-3.3 1.2-.4 2.4-.8 3.6-1 .6-.1 1.3-.2 1.9 0 .6.1 1.2.3 1.8.6 2.3 1 4.3 2.9 5.2 5.2.5 1.2.8 2.4.8 3.7.1 1.3-.3 2.5-1.2 3.4.9-.9 1.2-2.2 1.1-3.4-.1-1.2-.4-2.5-.9-3.6-1-2.3-3-4-5.2-5-2.3-1.2-4.8-.3-7.1.5-2.3.9-4.6 1.9-6.6 3.4-.5.4-1 .7-1.4 1.2-.2.2-.3.4-.5.7-.1.3-.2.6-.2.8-.2 1.2-.2 2.4 0 3.6.1 1.2.4 2.4.9 3.5.4 1.1 1.2 2 2.1 2.9.9.9 1.8 1.7 2.7 2.6l.7.7c.1.1.2.3.3.5.1.3.1.4.1.5l.4 1.8c.5 2.4 1 4.9 1.5 7.3 2.2 9.6 4.4 19.7 11 27.4 2.9 4 6 8 9 11.9 1.5 2 3.1 3.9 4.6 5.9l2.3 2.9 2.7 3z"
              />
              <path
                  className="success-spaceman-new_svg__st15"
                  d="M254.5 200.9c.8 1.4 1.8 2.8 3.2 3.6 1.4.8 3 .9 4.6.7 1.6-.2 3.2-.6 4.8-1 .8-.2 1.6-.5 2.3-.8.7-.3 1.5-.7 2.1-1.3-1.1 1.3-2.7 2.1-4.2 2.6-1.6.6-3.2 1-4.9 1.2-1.7.2-3.5 0-5-1-1.5-.9-2.4-2.5-2.9-4zM331.2 260.1c1.5-1.4 3-3 4-4.8 1-1.8 1.6-3.8 1.5-5.8 0-2-.5-4.1-1.3-6-.8-1.9-1.9-3.7-3.2-5.3 1.5 1.5 2.8 3.2 3.7 5.1.9 1.9 1.5 4 1.6 6.2 0 2.2-.6 4.3-1.8 6.1-.3.4-.6.9-.9 1.3l-1.1 1.2c-.8.7-1.6 1.5-2.5 2z"
              />
              <path
                  className="success-spaceman-new_svg__st15"
                  d="M334 264c2-2 4-4.2 5.5-6.6 1.5-2.4 2.4-5.2 2.3-8 0-2.8-.9-5.6-2.1-8.1-1.3-2.6-3-4.9-4.7-7.2 2 2.1 3.8 4.4 5.2 6.9 1.4 2.5 2.3 5.4 2.4 8.4 0 3-1 5.9-2.6 8.3-1.7 2.4-3.7 4.5-6 6.3zM325.3 294c.6-.1 1.3-.1 1.9-.2.6-.1 1.3 0 1.9-.2 1.2-.3 2.1-1.1 2.5-2.2.2-.5.2-1.1.2-1.8 0-.6 0-1.3.1-1.9.1-1.3.1-2.6.3-3.9.2 1.3.2 2.6.3 3.9 0 .6 0 1.3.1 1.9 0 .6.1 1.3-.2 2-.4 1.4-1.7 2.4-3.1 2.6-1.5.1-2.7-.1-4-.2zM294 248.1c0-.2.1-.4.2-.5l.4-.2c.2-.1.5-.3.7-.4.5-.2 1-.5 1.5-.7 1-.4 2.1-.7 3.2-1 2.2-.5 4.4-.6 6.6-.6 2.2 0 4.5.4 6.6 1.1 2.1.7 4.1 1.8 5.8 3.2-1.8-1.2-3.8-2.1-5.9-2.7-2.1-.6-4.3-.9-6.4-.9-2.2 0-4.4.2-6.5.6-1.1.2-2.1.5-3.1.9l-1.5.6-.7.4-.4.2c-.1.1-.3.1-.5 0z"
              />
              <path
                  className="success-spaceman-new_svg__st15"
                  d="M286.8 248.1l3.6-.3c1.2-.1 2.4-.1 3.6-.1h.9l-.7.6c-.1.1-.2.2-.3.4-.1.1-.1.2-.1.4s0 .5-.1.7c-.1.2-.2.4-.4.6-.1.1-.1.2-.2.3-.1.1-.3.2-.4.2-.3.1-.5.1-.7 0-.4 0-.8-.1-1.2-.3-.8-.3-1.5-.6-2.2-1-.7-.3-1.4-.8-1.8-1.5.6.5 1.3.9 2 1.3.7.3 1.5.6 2.2.8.4.1.8.2 1.1.2h.6l.2-.2c.2-.3.3-.5.3-.9 0-.2 0-.5.2-.7.1-.2.3-.4.5-.6l.2.6c-1.2 0-2.4 0-3.6-.1-1.3-.2-2.5-.2-3.7-.4zM320.7 248.1c1.8-.2 3.5-.2 5.3-.3.9 0 1.8-.1 2.7-.1 1 0 1.9.4 2.6 1.1.7.7 1.1 1.6 1.2 2.6 0 .9 0 1.8-.1 2.7-.1 1.8-.1 3.5-.3 5.3-.2-1.8-.2-3.5-.3-5.3l-.1-2.6c-.1-.8-.4-1.6-1-2.1-.6-.6-1.3-.9-2.1-.9-.9 0-1.8 0-2.6-.1-1.8 0-3.5-.1-5.3-.3zM288.3 294l-2.4.1c-.8 0-1.6.1-2.5 0-1.7-.2-3.2-1.8-3.3-3.5-.1-3.3-.1-6.5-.1-9.8 0-3.3 0-6.5.1-9.8.1-3.3.1-6.5.3-9.8.2 3.3.2 6.5.3 9.8.1 3.3.1 6.5.1 9.8l-.1 9.8c0 1.5 1.2 3 2.8 3.2 1.5.1 3.2.1 4.8.2z"
              />
              <circle
                  cx={307}
                  cy={268.4}
                  r={9.9}
                  fill="#b8e0ed"
                  stroke="#1d1d1d"
                  strokeWidth={0.717}
                  strokeMiterlimit={10}
              />
              <g>
                <circle
                    className="success-spaceman-new_svg__st1"
                    cx={300.5}
                    cy={267.1}
                    r={0.7}
                />
                <ellipse
                    className="success-spaceman-new_svg__st1"
                    cx={300.5}
                    cy={267.1}
                    rx={0.1}
                    ry={1.2}
                />
                <ellipse
                    className="success-spaceman-new_svg__st1"
                    cx={300.5}
                    cy={267.1}
                    rx={1.3}
                    ry={0.1}
                />
              </g>
              <g>
                <circle
                    className="success-spaceman-new_svg__st1"
                    cx={312.8}
                    cy={264.3}
                    r={0.8}
                />
                <ellipse
                    className="success-spaceman-new_svg__st1"
                    cx={312.8}
                    cy={264.3}
                    rx={0.1}
                    ry={1.4}
                />
                <ellipse
                    className="success-spaceman-new_svg__st1"
                    cx={312.8}
                    cy={264.3}
                    rx={1.5}
                    ry={0.1}
                />
              </g>
              <g>
                <circle
                    className="success-spaceman-new_svg__st1"
                    cx={304.6}
                    cy={261.5}
                    r={0.5}
                />
                <ellipse
                    className="success-spaceman-new_svg__st1"
                    cx={304.6}
                    cy={261.5}
                    rx={0.1}
                    ry={0.9}
                />
                <ellipse
                    className="success-spaceman-new_svg__st1"
                    cx={304.6}
                    cy={261.5}
                    rx={0.9}
                    ry={0.1}
                />
              </g>
              <g>
                <circle
                    className="success-spaceman-new_svg__st1"
                    cx={310.4}
                    cy={273.9}
                    r={0.4}
                />
                <ellipse
                    className="success-spaceman-new_svg__st1"
                    cx={310.4}
                    cy={273.9}
                    rx={0.1}
                    ry={0.7}
                />
                <ellipse
                    className="success-spaceman-new_svg__st1"
                    cx={310.4}
                    cy={273.9}
                    rx={0.7}
                    ry={0.1}
                />
              </g>
              <g>
                <circle
                    className="success-spaceman-new_svg__st1"
                    cx={306.6}
                    cy={275.2}
                    r={0.8}
                />
                <ellipse
                    className="success-spaceman-new_svg__st1"
                    cx={306.6}
                    cy={275.2}
                    rx={0.1}
                    ry={1.4}
                />
                <ellipse
                    className="success-spaceman-new_svg__st1"
                    cx={306.6}
                    cy={275.2}
                    rx={1.5}
                    ry={0.1}
                />
              </g>
              <g>
                <path
                    className="success-spaceman-new_svg__st17"
                    d="M302.5 270.6c.6.8 1.4 1 2.1 1 1.8 0 2.4-1 2.4-2.3v-4h-4v1.4h2.3v2.5c0 .8-.3 1-.8 1-.4 0-.8-.2-1.1-.6l-.9 1zM307 270.6c.6.8 1.4 1 2.1 1 1.8 0 2.4-1 2.4-2.3v-4h-4v1.4h2.3v2.5c0 .8-.3 1-.8 1-.4 0-.8-.2-1.1-.6l-.9 1z"
                />
              </g>
            </g>
          </g>
          <g
              id="success-spaceman-new_svg__Satallites"
              className="success-spaceman-new_svg__st19"
          >
            <g className="success-spaceman-new_svg__st21">
              <path
                  className="success-spaceman-new_svg__st27"
                  d="M156.3 131.8c-2.8 2.8-7.2 2.8-10 0M158.6 134c-4 4-10.5 4-14.4 0M160.8 136.3c-5.2 5.2-13.7 5.2-18.9 0"
              />
              <path
                  className="success-spaceman-new_svg__st5"
                  d="M106.7 91.3h-8.2v-8.2h8.2v8.2zm10.1-8.2h-8.2v8.2h8.2v-8.2zm10 0h-8.2v8.2h8.2v-8.2zm10.1 0h-8.2v8.2h8.2v-8.2zm-30.2 10.1h-8.2v8.2h8.2v-8.2zm10.1 0h-8.2v8.2h8.2v-8.2zm10 0h-8.2v8.2h8.2v-8.2zm10.1 0h-8.2v8.2h8.2v-8.2zm-30.2 10.1h-8.2v8.2h8.2v-8.2zm10.1 0h-8.2v8.2h8.2v-8.2zm10 0h-8.2v8.2h8.2v-8.2zm10.1 0h-8.2v8.2h8.2v-8.2zm36.8-20.2h-8.2v8.2h8.2v-8.2zm10.1 0h-8.2v8.2h8.2v-8.2zm10 0h-8.2v8.2h8.2v-8.2zm10.1 0h-8.2v8.2h8.2v-8.2zm-30.2 10.1h-8.2v8.2h8.2v-8.2zm10.1 0h-8.2v8.2h8.2v-8.2zm10 0h-8.2v8.2h8.2v-8.2zm10.1 0h-8.2v8.2h8.2v-8.2zm-30.2 10.1h-8.2v8.2h8.2v-8.2zm10.1 0h-8.2v8.2h8.2v-8.2zm10 0h-8.2v8.2h8.2v-8.2zm10.1 0h-8.2v8.2h8.2v-8.2zm-42.1 9.8V81c0-2.6-2.1-4.7-4.7-4.7h-11.7c-2.6 0-4.7 2.1-4.7 4.7v32.1c0 2.6 2.1 4.7 4.7 4.7h11.7c2.6 0 4.7-2.1 4.7-4.7zm3.8-16.8h-28.7v2.1h28.7v-2.1zm-13.3 21.5h-2.2v12.1h2.2v-12.1z"
              />
            </g>
          </g>
        </svg>
    )
  }
}

export default SvgSuccessSpaceman;
